
import BRadioCard from 'JS/components/blain-form/BRadioCard.vue';
import Icon from 'JS/components/Icon.vue';
import { defineComponent, PropType } from 'vue';
import { IconSubset } from 'JS/constants/icons';

export default defineComponent({
	components: {
		Icon,
		BRadioCard,
	},
	props: {
		name: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
		icon: {
			type: String as PropType<IconSubset<"auto-drop-off" | "auto-wait-appt">>,
			required: true,
		},
	},
	setup () {
		return {};
	}
});
